import CircularRectTextButton from "@/components/CircularButton/styled/CircularRectTextButton";
import { FlexColumn, FlexColumnAlignJustifyCenter, FlexRowAlignCenter } from "@/components/Flex";
import LinkWrapper from "@/components/wrappers/Link";
import { ASSETS_URL } from "@/config/deployConstants";
import br from "@/styles/breakpoints.module.css";
import { borderRadius } from "@/utils/borderRadius";
import { spacing } from "@/utils/spacing";
import { themeColors } from "@/utils/themeColors";
import { ArrowRight, Hourglass, Library, School } from "lucide-react";
import Image from "next/image";
import SectionContainer from "../../components/SectionContainer";

const Benefits = {
    Quizlet: [
        {
            img: <Hourglass />,
            color: themeColors.videoLight,
            title: "Start with Free Licenses for Every Teacher at your School ",
            description:
                "When you join the pilot program, you’ll receive FREE unlimited licenses for your school for 6 months. Have them try it out to make sure they actually love Knowt before taking the leap.",
        },
        {
            color: themeColors.docsLight,
            img: <Library />,
            title: "Lock in a cheaper price than Quizlet",
            description:
                "Once your pilot ends, if you choose to stick with Knowt, you’ll automatically lock in a price that’s cheaper than Quizlet for the next few years.",
        },
        {
            color: themeColors.pdfLight,
            img: <School />,
            title: "Stop paying for 5 tools.",
            description:
                "Get the functionality of Magic School, Quizlet, Quizziz, Brisk AI and SchoolAI in one tool. Less tools for you to manage -- one PO and one admin dashboard to manage everything",
        },
    ],
    Quizizz: [
        {
            img: <Hourglass />,
            color: themeColors.videoLight,
            title: "Start with Free Licenses for Every Teacher at your School",
            description:
                "When you join the pilot program, you’ll receive FREE unlimited licenses for your school for 6 months. Have them try it out to make sure they actually love Knowt before taking the leap.",
        },
        {
            color: themeColors.docsLight,
            img: <Library />,
            title: "Lock in a MUCH cheaper price than Quizizz",
            description:
                "Once your pilot ends, if you choose to stick with Knowt, you’ll automatically lock in a price that’s 50% cheaper than Quizizz for the next few years.",
        },
        {
            color: themeColors.pdfLight,
            img: <School />,
            title: "Stop paying for 5 tools.",
            description:
                "Get the functionality of Magic School, Quizlet, Quizziz, Brisk AI and SchoolAI in one tool. Less tools for you to manage -- one PO and one admin dashboard to manage everything",
        },
    ],
    SchoolAI: [
        {
            img: <Hourglass />,
            color: themeColors.videoLight,
            title: "Start with Free Licenses for Every Teacher at your School ",
            description:
                "When you join the pilot program, you’ll receive FREE unlimited licenses for your school for 6 months. Have them try it out to make sure they actually love Knowt before taking the leap.",
        },
        {
            color: themeColors.docsLight,
            img: <Library />,
            title: "Lock in a MUCH cheaper price than School AI",
            description:
                "Once your pilot ends, if you choose to stick with Knowt, you’ll automatically lock in a price that’s 50% cheaper than School AI for the next few years.",
        },
        {
            color: themeColors.pdfLight,
            img: <School />,
            title: "Stop paying for 5 tools.",
            description:
                "Get the functionality of Magic School, Quizlet, Quizziz, Brisk AI and SchoolAI in one tool. Less tools for you to manage -- one PO and one admin dashboard to manage everything",
        },
    ],
    MagicSchool: [
        {
            img: <Hourglass />,
            color: themeColors.videoLight,
            title: "Start with Free Licenses for Every Teacher at your School",
            description:
                "When you join the pilot program, you’ll receive FREE unlimited licenses for your school for 6 months. Have them try it out to make sure they actually love Knowt before taking the leap.",
        },
        {
            color: themeColors.docsLight,
            img: <Library />,
            title: "Lock in a MUCH cheaper price than Magic School AI",
            description:
                "Once your pilot ends, if you choose to stick with Knowt, you’ll automatically lock in a price that’s 50% cheaper than Magic School for the next few years.",
        },
        {
            color: themeColors.pdfLight,
            img: <School />,
            title: "Stop paying for 5 tools.",
            description:
                "Get the functionality of Magic School, Quizlet, Quizziz, Brisk AI and SchoolAI in one tool. Less tools for you to manage -- one PO and one admin dashboard to manage everything",
        },
    ],
    Brisk: [
        {
            img: <Hourglass />,
            color: themeColors.videoLight,
            title: "Start with Free Licenses for Every Teacher at your School ",
            description:
                "When you join the pilot program, you’ll receive FREE unlimited licenses for your school for 6 months. Have them try it out to make sure they actually love Knowt before taking the leap.",
        },
        {
            color: themeColors.docsLight,
            img: <Library />,
            title: "Lock in a cheaper price than Brisk Teaching",
            description:
                "Once your pilot ends, if you choose to stick with Knowt, you’ll automatically lock in a price that’s 50% cheaper than Brisk Teaching for the next few years.",
        },
        {
            color: themeColors.pdfLight,
            img: <School />,
            title: "Stop paying for 5 tools.",
            description:
                "Get the functionality of Magic School, Quizlet, Quizziz, Brisk AI and SchoolAI in one tool. Less tools for you to manage -- one PO and one admin dashboard to manage everything",
        },
    ],
    General: [
        {
            img: <Hourglass />,
            color: themeColors.videoLight,
            title: "Start with Free Licenses for Every Teacher at your School ",
            description:
                "When you join the pilot program, you’ll receive FREE unlimited licenses for your school for 6 months. Have them try it out to make sure they actually love Knowt before taking the leap.",
        },
        {
            color: themeColors.docsLight,
            img: <Library />,
            title: "Lock in a MUCH cheaper price for longer",
            description:
                "Once your pilot ends, if you choose to stick with Knowt, you’ll automatically lock in a price that’s 50% cheaper than the other AI tools for the next few years.",
        },
        {
            color: themeColors.pdfLight,
            img: <School />,
            title: "Stop paying for 5 tools.",
            description:
                "Get the functionality of Magic School, Quizlet, Quizziz, Brisk AI and SchoolAI in one tool. Less tools for you to manage -- one PO and one admin dashboard to manage everything",
        },
    ],
};

const CompetitorName = {
    MagicSchool: "MagicSchool",
    SchoolAI: "SchoolAI",
    Quizizz: "Quizizz",
    Quizlet: "Quizlet",
    Brisk: "Brisk Teaching",
    General: "General",
};

const SwitchingBenefits = ({
    title,
    subtitle,
    competitor,
}: { title?: string; subtitle?: string; competitor: (typeof CompetitorName)[keyof typeof CompetitorName] }) => {
    return (
        <SectionContainer
            title={title ?? `Why switch to this ${CompetitorName[competitor]} Alternative?`}
            subtitle={
                subtitle ??
                "We know how tough it is to pick the right AI tool for your school so we wanted to make it an easy decision."
            }
            headerStyle={{
                maxWidth: "73rem",
            }}>
            <FlexColumnAlignJustifyCenter style={{ gap: "4rem" }}>
                <FlexRowAlignCenter
                    className={br.mdDownColumn}
                    style={{ gap: spacing.MD, alignItems: "stretch", flexWrap: "wrap" }}>
                    {Benefits[competitor].map((b, i) => (
                        <FlexColumn
                            key={`benefit-${i}`}
                            style={{
                                flex: 1,
                                minWidth: "30%",
                                gap: spacing.MD,
                                border: `2px solid ${themeColors.neutral1}`,
                                padding: spacing.MD,
                                borderRadius: borderRadius.card,
                            }}>
                            <FlexColumnAlignJustifyCenter
                                style={{
                                    backgroundColor: b.color,
                                    width: "6rem",
                                    height: "6rem",
                                    borderRadius: "11px",
                                }}>
                                {b.img}
                            </FlexColumnAlignJustifyCenter>
                            <span className="bodyBold1" style={{ fontSize: "16px" }}>
                                {b.title}
                            </span>
                            <FlexColumn style={{ flex: 1, justifyContent: "center", gap: spacing.MD }}>
                                <p className="secondaryText1">{b.description}</p>
                            </FlexColumn>
                        </FlexColumn>
                    ))}
                </FlexRowAlignCenter>

                <FlexRowAlignCenter
                    className={br.mdDownColumn}
                    style={{ flex: 1, width: "100%", alignItems: "stretch", gap: "4rem" }}>
                    <LinkWrapper href={"/free-ai-tools-for-teachers"}>
                        <FlexColumnAlignJustifyCenter
                            style={{
                                flex: 1,
                                backgroundColor: "#FCEDD5",
                                padding: "3rem",
                                borderRadius: borderRadius.card,
                            }}>
                            <FlexRowAlignCenter style={{ justifyContent: "space-between", width: "100%" }}>
                                <span className="heading3" style={{ maxWidth: "32rem", color: themeColors.pureBlack }}>
                                    Knowt is the only tool you need.
                                </span>
                                <CircularRectTextButton
                                    component={"div"}
                                    style={{
                                        backgroundColor: themeColors.pureBlack,
                                        padding: spacing.XS,
                                        borderRadius: borderRadius.circular,
                                    }}>
                                    <ArrowRight
                                        size={46}
                                        color={themeColors.pureWhite}
                                        style={{ transform: "rotate(-45deg)" }}
                                    />
                                </CircularRectTextButton>
                            </FlexRowAlignCenter>
                            <Image
                                src={`${ASSETS_URL}/images/knowt-is-nbr-1.svg`}
                                alt={"ai tool"}
                                width={420}
                                height={200}
                                style={{ flexShrink: 0, width: "100%" }}
                            />
                        </FlexColumnAlignJustifyCenter>
                    </LinkWrapper>

                    <LinkWrapper href={"https://help.knowt.com"}>
                        <FlexColumnAlignJustifyCenter
                            style={{
                                flex: 1,
                                backgroundColor: "#F0F5F2",
                                padding: "3rem",
                                borderRadius: borderRadius.card,
                                gap: "1rem",
                            }}>
                            <FlexRowAlignCenter style={{ justifyContent: "space-between", width: "100%" }}>
                                <span
                                    className="heading3"
                                    style={{ maxWidth: "28.5rem", color: themeColors.pureBlack }}>
                                    No steep learning curve
                                </span>
                                <CircularRectTextButton
                                    style={{
                                        backgroundColor: themeColors.pureBlack,
                                        padding: spacing.XS,
                                        borderRadius: borderRadius.circular,
                                    }}>
                                    <ArrowRight
                                        size={46}
                                        color={themeColors.pureWhite}
                                        style={{ transform: "rotate(-45deg)" }}
                                    />
                                </CircularRectTextButton>
                            </FlexRowAlignCenter>
                            <Image
                                src={`${ASSETS_URL}/images/learning-curve.svg`}
                                alt={"ai tool"}
                                width={420}
                                height={200}
                                style={{ flexShrink: 0, width: "100%" }}
                            />
                        </FlexColumnAlignJustifyCenter>
                    </LinkWrapper>
                </FlexRowAlignCenter>
            </FlexColumnAlignJustifyCenter>
        </SectionContainer>
    );
};

export default SwitchingBenefits;
